import { gql } from "@apollo/client";
import client from "../apolloClient";
import {
  Restaurant,
  RestaurantCreateFormData,
  RestaurantResult,
  RestaurantFilters,
  UpdateRestaurantPayload,
} from "../../schemas/restaurantSchema";

const GET_RESTAURANTS = gql`
  query GetRestaurants($page: Int, $pageSize: Int, $search: String) {
    restaurants(page: $page, pageSize: $pageSize, search: $search) {
      restaurants {
        id
        code
        name
        description
        tenantId
        createdBy
        createdAt
        updatedAt
      }
      page
      pageSize
      total
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;

const GET_RESTAURANT_BY_ID = gql`
  query GetRestaurantById($id: ID!) {
    restaurant(id: $id) {
      id
      code
      name
      description
      tenantId
      createdBy
      createdAt
      updatedAt
    }
  }
`;

const CREATE_RESTAURANT = gql`
  mutation CreateRestaurant($input: CreateRestaurantInput!) {
    createRestaurant(input: $input)
  }
`;

const UPDATE_RESTAURANT = gql`
  mutation UpdateRestaurant($id: ID!, $input: UpdateRestaurantInput!) {
    updateRestaurant(id: $id, input: $input)
  }
`;

const DELETE_RESTAURANTS = gql`
  mutation DeleteRestaurants($ids: [ID!]!) {
    deleteRestaurants(ids: $ids)
  }
`;

export const restaurantService = {
  getAll: async (
    filters: RestaurantFilters = {},
  ): Promise<RestaurantResult> => {
    const { data } = await client.query({
      query: GET_RESTAURANTS,
      variables: filters,
      fetchPolicy: "network-only",
    });
    return data.restaurants;
  },

  getById: async (id: string): Promise<Restaurant> => {
    const { data } = await client.query({
      query: GET_RESTAURANT_BY_ID,
      variables: { id },
      fetchPolicy: "network-only",
    });
    return data.restaurant;
  },

  create: async (input: RestaurantCreateFormData): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: CREATE_RESTAURANT,
      variables: { input },
    });
    return data.createRestaurant;
  },

  update: async (payload: UpdateRestaurantPayload): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: UPDATE_RESTAURANT,
      variables: {
        id: payload.id,
        input: payload.restaurant,
      },
    });
    return data.updateRestaurant;
  },

  remove: async (ids: string[]): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: DELETE_RESTAURANTS,
      variables: { ids },
    });
    return data.deleteRestaurants;
  },
};
